<template>
	<div class="full">
		<vxe-table :loading="loading" :data="Inventoryquantityadjustbill" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="billCode" title="单据编码"></vxe-column>
			<vxe-column field="bizDate" title="业务时间"></vxe-column>
			<vxe-column field="storageName" title="仓库"></vxe-column>
			<vxe-column field="skuCode" title="商品编码"></vxe-column>
			<vxe-column field="size" title="数量"></vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				Inventoryquantityadjustbill: [],
				warehouse:[],
				loading:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if(this.row){
				this.getInventoryquantityadjustbill()
			}else{
				this.Inventoryquantityadjustbill = []
			}
		},
		computed: {

		},

		methods: {
			getInventoryquantityadjustbill() {
				this.loading = true
				this.$api.goods.getInventoryquantityadjustbill(this.row.id).then((res) => {
					this.Inventoryquantityadjustbill = res['Inventoryquantityadjustbill']
					this.loading = false
				},()=>{
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>